const menaCountriesIds = {
    development: [5664,5674,5713,5740,5746,5751,5755,5778,5791,5794,5802,5812,5824,5827,5832,5841,5847,5856],
    production: [5664,5674,5713,5740,5746,5751,5755,5778,5791,5794,5802,5812,5824,5827,5832,5841,5847,5856]
}

export const MENA_COUNTRIES = menaCountriesIds[process.env.NODE_ENV];

const turkeyCountryId = {
    development: 5842,
    production: 5842
}

export const TURKEY_COUNTRY_ID = turkeyCountryId[process.env.NODE_ENV];

const pakistanCountryId = {
    development: 5792,
    production: 5792
}

export const PAKISTAN_COUNTRY_ID = pakistanCountryId[process.env.NODE_ENV];